class LoginService {
  loginResponse: MemberSerializerResponse<IUser>
  user: IUser
  contact: IContact
  supplierStations: ISupplierStation[]
  contactOrganizations: IContactOrganization[]

  constructor(loginResponse: MemberSerializerResponse<IUser>) {
    this.loginResponse = loginResponse
  }

  startSession() {
    this.prepareUserContext()
    return this.reducerPayload()
  }

  prepareUserContext() {
    this.user = this.loginResponse.data.attributes
    this.contact = this.loginResponse.included.find(
      (included) => included.type === 'contact'
    ).attributes
    this.contactOrganizations = this.loginResponse.included
      .filter((included) => included.type === 'contact_organization')
      .map((co) => co.attributes)
    this.supplierStations = this.loginResponse.included
      .filter((included) => included.type === 'supplier_station')
      .map((st) => st.attributes)
  }

  reducerPayload() {
    return {
      user: this.user,
      contact: this.contact,
      contactOrganizations: this.contactOrganizations,
      supplierStations: this.supplierStations
    }
  }
}

export default LoginService
